type WithdrawalChangeData = {
  RequestId: number;
  State: string;
  Message: string;
};

function transformWithdrawalChange(data: WithdrawalChangeData) {
  const {
    RequestId: requestId,
    State: requestState,
    Message: requestDescription,
  } = data;

  return {
    requestId,
    requestState,
    requestDescription,
  };
}

export { transformWithdrawalChange };
